export const USER_SEARCH_INDEX_FIELDS = Object.freeze({
  email: 'searchEmail',
  firstName: 'searchFirstName',
  lastName: 'searchLastName',
  username: 'searchUsername',
});

export const normalizeUserSearchValue = (value) =>
  typeof value === 'string' ? value.trim().toLowerCase() : '';

export const capitalizeFirstCharacter = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return '';
  }

  return `${trimmedValue.charAt(0).toUpperCase()}${trimmedValue.slice(1)}`;
};

export const buildUserSearchIndex = (user = {}) =>
  Object.entries(USER_SEARCH_INDEX_FIELDS).reduce((nextIndex, [field, indexField]) => {
    nextIndex[indexField] = normalizeUserSearchValue(user[field]);
    return nextIndex;
  }, {});

export const getNormalizedUserSearchFilter = (filter = {}) =>
  Object.keys(USER_SEARCH_INDEX_FIELDS).reduce((nextFilter, field) => {
    const normalizedValue = normalizeUserSearchValue(filter[field]);

    if (normalizedValue) {
      nextFilter[field] = normalizedValue;
    }

    return nextFilter;
  }, {});

export const userMatchesSearchFilter = (user = {}, filter = {}) => {
  const normalizedFilter = getNormalizedUserSearchFilter(filter);

  return Object.entries(normalizedFilter).every(([field, normalizedValue]) => {
    const indexField = USER_SEARCH_INDEX_FIELDS[field];
    const userValue = user[indexField] || user[field];
    return normalizeUserSearchValue(userValue) === normalizedValue;
  });
};

const getTimestampValue = (value) => {
  if (!value) {
    return 0;
  }

  if (typeof value?.seconds === 'number') {
    return value.seconds * 1000;
  }

  if (value instanceof Date) {
    return value.getTime();
  }

  if (typeof value === 'number') {
    return value < 1e12 ? value * 1000 : value;
  }

  if (typeof value === 'string') {
    const parsedValue = Date.parse(value);
    return Number.isNaN(parsedValue) ? 0 : parsedValue;
  }

  return 0;
};

export const sortUsersByCreatedAtDesc = (leftUser = {}, rightUser = {}) =>
  getTimestampValue(rightUser.createdAt || rightUser.createdTime) -
  getTimestampValue(leftUser.createdAt || leftUser.createdTime);
